import createEntrypoint from './approot/createEntrypoint';
import UnauthenticatedApp from './approot/UnauthenticatedApp';

createEntrypoint(UnauthenticatedApp);
